var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('multiselect', {
    staticClass: "event-selector",
    attrs: {
      "options": _vm.safeOptions,
      "multiple": true,
      "close-on-select": false,
      "show-labels": false,
      "allow-empty": true,
      "preserve-search": true,
      "searchable": false,
      "placeholder": _vm.$i18n.t('customer-project.modal.invite.choose').toString(),
      "label": "name",
      "track-by": "id"
    },
    on: {
      "select": _vm.onSelect,
      "remove": _vm.onRemove
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (_ref) {
        var values = _ref.values,
          isOpen = _ref.isOpen;
        return [values.length && !isOpen ? _c('span', {
          staticClass: "multiselect__single"
        }, [_vm._v(" " + _vm._s(values.length) + " " + _vm._s(_vm.$i18n.t('customer-project.modal.invite.options-selected')) + " ")]) : _vm._e()];
      }
    }, {
      key: "tag",
      fn: function () {
        return [_c('span')];
      },
      proxy: true
    }]),
    model: {
      value: _vm.values,
      callback: function ($$v) {
        _vm.values = $$v;
      },
      expression: "values"
    }
  });

}
var staticRenderFns = []

export { render, staticRenderFns }